// eslint-disable-next-line import/prefer-default-export
import { Currency } from '../configs/language';
import { SelectOption } from './common/types';

type SwiftCurrency = {
  key: string;
  value: Currency;
};

export enum CountryBankAccount {
  MX = 'clabe',
  USA = 'routingNumber',
  COL = 'accountNumber',
}

export enum TransferMethodIdEnum {
  WIRE = '1',
  ACH = '2',
}

export enum TransferMethodEnum {
  WIRE = 'WIRE',
  ACH = 'ACH',
}

export const dropdownOptionsCurrency: SwiftCurrency[] = [
  { key: 'MXN', value: 'MXN' },
  { key: 'USD', value: 'USD' },
];

export const CHINA_SWIFT_CURRENCIES: SwiftCurrency[] = [
  { key: 'CNY', value: 'CNY' },
  { key: 'USD', value: 'USD' },
];

export const JAPAN_SWIFT_CURRENCIES: SwiftCurrency[] = [
  { key: 'JPY', value: 'JPY' },
];

export const dropdownOptionsSWIFTCurrency: SwiftCurrency[] = [
  { key: 'AUD', value: 'AUD' },
  { key: 'CAD', value: 'CAD' },
  { key: 'CNY', value: 'CNY' },
  { key: 'CHF', value: 'CHF' },
  { key: 'EUR', value: 'EUR' },
  { key: 'GBP', value: 'GBP' },
  { key: 'PLN', value: 'PLN' },
  { key: 'USD', value: 'USD' },
];

export const TRANSFER_METHOD_OPTIONS: SelectOption[] = [
  { id: TransferMethodIdEnum.WIRE, value: TransferMethodEnum.WIRE },
  { id: TransferMethodIdEnum.ACH, value: TransferMethodEnum.ACH },
];
